import { SupervisorGroup } from '../types';

export enum SupervisorGroupActionType {
    GET_ALL_SUPERVISOR_GROUPS = 'GET_ALL_SUPERVISOR_GROUPS',
    GET_SUPERVISOR_GROUP = 'GET_SUPERVISOR_GROUP',
    CREATE_SUPERVISOR_GROUP = 'CREATE_SUPERVISOR_GROUP',
    UPDATE_SUPERVISOR_GROUP = 'UPDATE_SUPERVISOR_GROUP',
    DELETE_SUPERVISOR_GROUPS = 'DELETE_SUPERVISOR_GROUPS',
    MERGE_SUPERVISOR_GROUPS = 'MERGE_SUPERVISOR_GROUPS',
    CLEAR_SUPERVISOR_GROUPS = 'CLEAR_SUPERVISOR_GROUPS',
}

interface GetAllSupervisorGroupsAction {
    type: SupervisorGroupActionType.GET_ALL_SUPERVISOR_GROUPS;
    payload: Array<SupervisorGroup>;
}

interface GetSupervisorGroupAction {
    type: SupervisorGroupActionType.GET_SUPERVISOR_GROUP;
    payload: SupervisorGroup;
}
interface CreateSupervisorGroupAction {
    type: SupervisorGroupActionType.CREATE_SUPERVISOR_GROUP;
    payload: SupervisorGroup;
}

interface UpdateSupervisorGroupAction {
    type: SupervisorGroupActionType.UPDATE_SUPERVISOR_GROUP;
    payload: SupervisorGroup;
}

interface DeleteSupervisorGroupsAction {
    type: SupervisorGroupActionType.DELETE_SUPERVISOR_GROUPS;
    payload: Array<SupervisorGroup>;
}

interface MergeSupervisorGroupsAction {
    type: SupervisorGroupActionType.MERGE_SUPERVISOR_GROUPS;
    payload: Array<SupervisorGroup>;
}

interface ClearSupervisorGroupsAction {
    type: SupervisorGroupActionType.CLEAR_SUPERVISOR_GROUPS;
    payload: [];
}

export type SupervisorGroupAction =
    | GetAllSupervisorGroupsAction
    | GetSupervisorGroupAction
    | CreateSupervisorGroupAction
    | UpdateSupervisorGroupAction
    | DeleteSupervisorGroupsAction
    | MergeSupervisorGroupsAction
    | ClearSupervisorGroupsAction;
